import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = () => {
    return (
        <div className="w-100 d-flex pt-2 justify-content-center bg-light text-dark mb-1">
            <h1 className="text-dark font-weight-bold fs-6">Made with &#9829; by Abhishek Biyani</h1>
        </div>
    );
};

export default Footer;
